module.exports = __webpack_public_path__ + "static/media/homework-card-footer.695f3e3f.png";